import {useEffect, useState} from 'react';
import {type ContextMenuServiceContextType} from '@netx/core-components/ContextMenu';

export type UseIsRowContextMenuOpenParams = {
	contextMenu: Pick<ContextMenuServiceContextType, 'isOpen'>;
};

export const useIsRowContextMenuOpen = ({
	contextMenu,
}: UseIsRowContextMenuOpenParams) => {
	const [rowContextMenuOpen, setRowContextMenuOpen] = useState<string>();

	useEffect(() => {
		if (!contextMenu.isOpen) setRowContextMenuOpen(undefined);
	}, [contextMenu.isOpen]);

	return {
		rowContextMenuOpen,
		setRowContextMenuOpen,
	};
};
